
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { IndividualFileCategories } from 'ah-api-gateways';
import AsyncImage from '@/app/components/common/AsyncImage.vue';
import UploadButton from 'ah-common-lib/src/common/components/upload/UploadButton.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    UploadButton,
    AsyncImage,
  },
})
export default class ProfilePhotoEditor extends Mixins(WithRequestManager) {
  imageSrc = '';
  requestManagerConfig = {
    exposeToParent: false,
  };

  @Watch('photo.id', { immediate: true })
  onPhotoIdChange() {
    if (this.photo) {
      this.$services.individual
        .getDocumentAsBlob(this.authStore.loggedInIdentity!.id, this.photo!)
        .subscribe((blob) => {
          if (this.imageSrc) {
            URL.revokeObjectURL(this.imageSrc);
          }
          this.imageSrc = URL.createObjectURL(blob!);
        });
    }
  }

  beforeDestroy() {
    if (this.imageSrc) {
      URL.revokeObjectURL(this.imageSrc);
    }
  }

  created() {
    this.individualSettingsStore.loadIndividualDocuments(true);
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get photo() {
    return this.individualSettingsStore.getIndividualDocument(IndividualFileCategories.PROFILE_PICTURE);
  }

  get authStore() {
    return useAuthStore();
  }

  uploadPhoto(files: File[]) {
    const file = files[0];

    if (file) {
      if (file.size > 10485760) {
        this.$toast.error(`File size exceeds maximum allowed of 10 MB`);
      } else if (!file.type.startsWith('image')) {
        this.$toast.error(`File must be an image (.BMP, .JPEG, .GIF, .TIF, .PNG)`);
      } else {
        this.requestManager
          .currentOrNew(
            'uploadPhoto',
            this.individualSettingsStore.uploadIndividualDocument(file, IndividualFileCategories.PROFILE_PICTURE)
          )
          .subscribe();
      }
    }
  }
}
